import { useSelector } from 'react-redux';

import type { CommonListAppState } from '../../../redux/common_list/types';

export function useListState<ListName extends string>(listName: ListName) {
  const listState = useSelector(
    (state: { [key in ListName]: CommonListAppState }) =>
      listName in state ? state[listName] : undefined,
  );
  if (!listState) {
    throw new Error(`List state not found for ${listName}`);
  }
  return listState;
}
